<div class="tile-container-skeleton" *ngIf="loadingData">
  <div fxLayoutAlign="center">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="tile-container" *ngIf="!loadingData">
  <div fxLayout="column">
    <div fxLayout="row" class="tile-header">
      Traffic by Affiliate in Micro-moment
    </div>
    <div fxLayout="row" fxFlex="100%">
      <div fxLayout="column" fxFlex="50%">
        <mat-radio-group
          fxLayout="column"
          fxLayoutGap="10px"
          [(ngModel)]="displayField"
          (change)="changeDisplayValue($event)"
        >
          <mat-radio-button value="lift" fxLayout="row">Avg. Lift</mat-radio-button>
          <mat-radio-button value="sessions" fxLayout="row">Avg. Sessions</mat-radio-button>
          <mat-radio-button value="pageviews" fxLayout="row">Avg. Pages visited</mat-radio-button>
        </mat-radio-group>
      </div>
      <div fxLayout="column" fxFlex="50%">
        <mat-form-field appearance="outline">
          <mat-label>Creative</mat-label>
          <mat-select
            [(ngModel)]="selectedCreative"
            [ngModelOptions]="{ standalone: true }"
            (selectionChange)="changeSelectedCreative($event)"
          >
            <mat-option value="All">All</mat-option>
            <mat-option *ngFor="let c of creatives" [value]="c">
              {{ c }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="chart-container">
<!--      <x-chartist-->
<!--        [type]="'Bar'"-->
<!--        fxLayout="row"-->
<!--        class="chart"-->
<!--        id="traffic-by-affiliate"-->
<!--        [data]="chartData"-->
<!--        [options]="chartOpts"-->
<!--        [events]="chartEvents"-->
<!--        (initialized)="chartInitialized($event)"-->
<!--      ></x-chartist>-->
    </div>
  </div>
</div>
